
// PHX-7218: Sanitizes contaminated URL query parameter values that contain encoded query strings.
// When URLs are improperly constructed, marketing parameters can become contaminated with other query parameters.
// This contamination corrupts analytics tracking and marketing attribution data.
// This function checks if the parameter name is a marketing parameter and if the value contains an ampersand.

export const sanitizeQueryParameterValue = (paramName, value) => {
  if (!value || typeof value !== 'string') return value;
  const marketingParams = new Set(['icode']);
  if (marketingParams.has(paramName.toLowerCase()) && value.includes('&')) {
    return value.split('&')[0];
  }
  return value;
};
